import React, {
    createContext, useState, useMemo, 
   } from 'react';
   import PropTypes from 'prop-types';
   
   export const DashboardContext = createContext();
   
   const DashboardContextProvider = ({ children }) => {
    const [Totalmeal, setTotalmeal] = useState(0);
    const [Restaurantlocation, setRestaurantlocation] = useState(0);

  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    Totalmeal,
    setTotalmeal,
    Restaurantlocation,
    setRestaurantlocation,
  }), [Totalmeal]);

   
     return (
       <DashboardContext.Provider value={value}>
         {children}
       </DashboardContext.Provider>
     );
   };
   
   DashboardContextProvider.propTypes = {
     children: PropTypes.node.isRequired,
   };
   
   export default DashboardContextProvider;
